import { StorageObjectEventType } from '@navio/nsdk';

type StorageEventCopy = {
  title: string;
  description: string;
  past: string;
};

export const storageEventCopy = {
  mountedOnCar: {
    title: 'Mounted on car',
    description: 'Mounted during a wheel change.',
    past: 'mounted on the car'
  },
  pickedUpByCustomer: {
    title: 'Picked up by customer',
    description: 'The customer collected them.',
    past: 'picked up by the customer'
  },
  deliveredToCustomer: {
    title: 'Delivered to customer',
    description: 'We delivered them to the customer.',
    past: 'delivered to the customer'
  },
  pickedUpFromCustomer: {
    title: 'Picked up from customer',
    description: 'We picked them up from the customer.',
    past: 'picked up from the customer'
  },
  removeFromStorageUnit: {
    title: 'Remove from storage unit',
    description: 'Take them off their current storage unit.',
    past: 'removed from the storage unit'
  },
  moveToStorageUnit: {
    title: 'Move to storage unit',
    description: 'Place them on a storage unit.',
    past: 'moved to a storage unit'
  }
} as const satisfies Record<string, StorageEventCopy>;

export const storageMoveSectionCopy = {
  withTheCustomer: 'With the customer',
  storageUnit: 'Storage unit',
  fromTheCustomer: 'From the customer'
} as const;

export const withCustomerStorageEventTypes = [
  StorageObjectEventType.MOUNTED_ON_CAR,
  StorageObjectEventType.PICKED_UP_BY_CUSTOMER,
  StorageObjectEventType.DELIVERED_TO_CUSTOMER
] as const;

export const withCustomerStatusLabel = (eventType: StorageObjectEventType): string => {
  switch (eventType) {
    case StorageObjectEventType.MOUNTED_ON_CAR:
      return storageEventCopy.mountedOnCar.title;
    case StorageObjectEventType.PICKED_UP_BY_CUSTOMER:
      return storageEventCopy.pickedUpByCustomer.title;
    default:
      return storageEventCopy.deliveredToCustomer.title;
  }
};

// Backend choice labels are developer notes. These are the words shown in the product.
export const storageEventTypeLabels: Record<StorageObjectEventType, string> = {
  PICKED_UP_FROM_CUSTOMER: storageEventCopy.pickedUpFromCustomer.title,
  MOUNTED_ON_CAR: storageEventCopy.mountedOnCar.title,
  PICKED_UP_BY_CUSTOMER: storageEventCopy.pickedUpByCustomer.title,
  DELIVERED_TO_CUSTOMER: storageEventCopy.deliveredToCustomer.title,
  LOADED_ONTO_VEHICLE: 'Loaded onto vehicle',
  INTERNAL_PICKUP: storageEventCopy.removeFromStorageUnit.title,
  INTERNAL_DELIVERY: storageEventCopy.moveToStorageUnit.title,
  PICKED_UP_FROM_SUPPLIER: 'Picked up from supplier',
  MOUNTED_TIRE_ON_WHEEL: 'New tires mounted on rim',
  EVENT_RETRACTED: 'Event undone',
  DETAILS_CHANGED: 'Storage details updated',
  LABEL_PRINTED: 'Label printed',
  LABEL_REPLACED: 'Label replaced',
  LOST: 'Lost',
  DISCARDED: 'Discarded'
};

export const storageEventTypeLabel = (eventType: { value: StorageObjectEventType; label: string }): string =>
  storageEventTypeLabels[eventType.value] ?? eventType.label;
